/* HayPost USA — interactions & animation (safety-first) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----- Scroll progress bar ----- */
  var progress = document.querySelector('.scroll-progress');
  function updateProgress() {
    if (!progress) return;
    var doc = document.documentElement;
    var max = doc.scrollHeight - doc.clientHeight;
    var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
    progress.style.width = pct + '%';
  }

  /* ----- Sticky header shadow ----- */
  var header = document.querySelector('.site-header');
  function updateHeader() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  }

  /* ----- Scroll reveal: position checks, NO IntersectionObserver ----- */
  var revealEls = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
  function checkReveals() {
    if (reduceMotion) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = revealEls.length - 1; i >= 0; i--) {
      var el = revealEls[i];
      var rect = el.getBoundingClientRect();
      if (rect.top < vh - 60 || rect.bottom < vh) {
        el.classList.add('is-visible');
        revealEls.splice(i, 1);
      }
    }
  }

  /* ----- Stat count-up (final value stays in HTML; JS animates from 0) ----- */
  var statEls = Array.prototype.slice.call(document.querySelectorAll('[data-countup]'));
  statEls.forEach(function (el) { el.dataset.original = el.textContent; });

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-countup'));
    var decimals = (String(el.getAttribute('data-countup')).split('.')[1] || '').length;
    var original = el.dataset.original;
    var duration = 1400;
    var start = null;

    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(decimals);
      if (p < 1) { requestAnimationFrame(frame); } else { el.textContent = original; }
    }
    requestAnimationFrame(frame);
    /* Safety net: force-restore exact original text */
    setTimeout(function () { el.textContent = original; }, duration + 600);
  }

  function checkStats() {
    if (reduceMotion) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    for (var i = statEls.length - 1; i >= 0; i--) {
      var rect = statEls[i].getBoundingClientRect();
      if (rect.top < vh - 40) {
        animateCount(statEls[i]);
        statEls.splice(i, 1);
      }
    }
  }

  /* ----- rAF-throttled scroll handler ----- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateProgress();
      updateHeader();
      checkReveals();
      checkStats();
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ----- Timed safety net: force-settle EVERYTHING to final state ----- */
  setTimeout(function () {
    document.querySelectorAll('.reveal, .hero-anim').forEach(function (el) {
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.transition = 'none';
      el.classList.add('is-visible');
    });
    statEls.slice().forEach(function (el) {
      el.textContent = el.dataset.original;
    });
  }, 4000);

  /* ----- Mobile menu ----- */
  var toggle = document.querySelector('.nav-toggle');
  var menu = document.querySelector('.mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Initial pass */
  updateProgress();
  updateHeader();
  checkReveals();
  checkStats();
})();
